module.exports = "<div class=\"ui grid\">\n    <div class=\"two column row\">\n        <div class=\"left floated column\">\n            <div class=\"ui basic segment\">\n                <header-logo></header-logo>\n            </div>\n        </div>\n        <div class=\"right floated right aligned column\">\n            <div class=\"ui basic segment\">\n                <project-buttons></project-buttons>\n            </div>\n        </div>\n    </div>\n</div>\n<task></task>\n<work></work>";


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/component/app/app.cmp.html
 ** module id = 413
 ** module chunks = 0
 **/